export class StoryTheme {
  public id: string;
  public name: string;

  constructor(data: Partial<StoryTheme> = {}) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
  }

  public static createFromApi(data: Partial<StoryTheme> = {}): StoryTheme {
    return new StoryTheme(data);
  }

  public processForApi(): Record<string, any> {
    return {
      id: this.id,
      name: this.name,
    };
  }
}
